import { render, staticRenderFns } from "./promotionPoster.vue?vue&type=template&id=74502fcc&scoped=true&"
import script from "./promotionPoster.vue?vue&type=script&lang=js&"
export * from "./promotionPoster.vue?vue&type=script&lang=js&"
import style0 from "./promotionPoster.vue?vue&type=style&index=0&id=74502fcc&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74502fcc",
  null
  
)

export default component.exports